export { default as StudentModal } from './StudentModal'
